import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import "./HeroSection.css";

const HeroSection = () => {
  const heroRef = useRef(null);
  const [vantaEffect, setVantaEffect] = useState(null);

  useEffect(() => {
    if (!vantaEffect && window.VANTA) {
      setVantaEffect(
        window.VANTA.DOTS({
          el: heroRef.current,
          mouseControls: true,
          touchControls: true,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 1.0,
          color: 0x9ADBD6,
          color2: 0x206bff,
          backgroundColor: 0x010119,
          size: 3.0,
          spacing: 40.0,
        })
      );
    }

    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);

  return (
    <div ref={heroRef} className="hero-container">
      <h1 className="hero-title">
        Explore the <span className="gradient-text">Quantum Realm</span>
      </h1>
      <p className="hero-subtitle">
        Join our vibrant community of industry experts, researchers, academics, innovators and enthusiasts
        shaping the future of quantum technologies.
      </p>
      <div className="hero-buttons">
        <Link to="/join-community">
        <button className="btn btn-primary">
          Get Started
          <span className="arrow-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1.5 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 1 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.793 8.5H2a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </span>
        </button>
        </Link>
      </div>
    </div>
  );
};

export default HeroSection;
